import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const CookiePolicy = () => {
  return (
    <>
      <Helmet>
        <title>Cookie Policy - Miranda Landa Services LLC</title>
        <meta name="description" content="Learn about how Miranda Landa Services LLC uses cookies and similar technologies on our website." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Cookie Policy
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              What Are Cookies?
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              How We Use Cookies
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Miranda Landa Services LLC uses cookies for the following purposes:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors use our website</li>
              <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
              <li><strong>Performance Cookies:</strong> Improve website speed and performance</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Types of Cookies We Use
            </h2>
            
            <div style={{marginBottom: '2rem'}}>
              <h3 style={{fontSize: '1.3rem', fontWeight: '600', color: '#059669', marginBottom: '0.75rem'}}>
                Strictly Necessary Cookies
              </h3>
              <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
                These cookies are essential for you to browse the website and use its features. Without these cookies, services you have requested cannot be provided.
              </p>
            </div>

            <div style={{marginBottom: '2rem'}}>
              <h3 style={{fontSize: '1.3rem', fontWeight: '600', color: '#059669', marginBottom: '0.75rem'}}>
                Analytics and Performance Cookies
              </h3>
              <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
                These cookies collect information about how visitors use our website, such as which pages are visited most often. This data helps us improve our website's functionality and user experience.
              </p>
            </div>

            <div style={{marginBottom: '2rem'}}>
              <h3 style={{fontSize: '1.3rem', fontWeight: '600', color: '#059669', marginBottom: '0.75rem'}}>
                Functionality Cookies
              </h3>
              <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
                These cookies allow the website to remember choices you make and provide enhanced, personalized features.
              </p>
            </div>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Managing Cookies
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              You can control and manage cookies in various ways:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Most browsers allow you to refuse or accept cookies</li>
              <li>You can delete cookies already stored on your device</li>
              <li>You can set your browser to notify you when cookies are being sent</li>
              <li>You can use browser privacy modes to limit cookie storage</li>
            </ul>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginTop: '1rem'}}>
              Please note that disabling cookies may affect the functionality of our website and your user experience.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Third-Party Cookies
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may use third-party services that set cookies on your device. These services include analytics providers and other service providers that help us operate our website. These third parties have their own privacy policies governing their use of cookies.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Updates to This Policy
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our business practices. We will notify you of any significant changes by posting the updated policy on our website.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#064e3b', marginBottom: '1rem'}}>
              Contact Us
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you have questions about our use of cookies, please contact us:
            </p>
            <div style={{
              background: '#f0fdf4',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #10b981'
            }}>
              <p style={{fontSize: '1rem', color: '#065f46', marginBottom: '0.5rem'}}>
                <strong>Miranda Landa Services LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#065f46'}}>
                Email: <a href="mailto:privacy@mirandaconnects.com" style={{color: '#059669'}}>privacy@mirandaconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/privacy" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              Privacy Policy
            </Link>
            <Link to="/terms" style={{
              background: 'white',
              color: '#059669',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #059669'
            }}>
              Terms of Service
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default CookiePolicy;
